var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4C2.25 3.58579 2.58579 3.25 3 3.25L16.5 3.25C16.9142 3.25 17.25 3.58579 17.25 4C17.25 4.41421 16.9142 4.75 16.5 4.75L3 4.75C2.58579 4.75 2.25 4.41421 2.25 4ZM2.25 9.33333C2.25 8.91912 2.58579 8.58333 3 8.58333L21 8.58333C21.4142 8.58333 21.75 8.91912 21.75 9.33333C21.75 9.74755 21.4142 10.0833 21 10.0833L3 10.0833C2.58579 10.0833 2.25 9.74755 2.25 9.33333ZM2.25 14.6667C2.25 14.2525 2.58579 13.9167 3 13.9167H16.5C16.9142 13.9167 17.25 14.2525 17.25 14.6667C17.25 15.0809 16.9142 15.4167 16.5 15.4167H3C2.58579 15.4167 2.25 15.0809 2.25 14.6667ZM2.25 20C2.25 19.5858 2.58579 19.25 3 19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLeft);
export default __webpack_public_path__ + "static/media/Text-left.7056b8898c185aef05734475422bc42d.svg";
export { ForwardRef as ReactComponent };